<template>
  <div class="opendialogs">
  <b-breadcrumb>
    <b-breadcrumb-item href="#">
      <AllBusinessCasesUngrouped></AllBusinessCasesUngrouped>
    </b-breadcrumb-item>
    <b-breadcrumb-item href="#home" active>
      <b-icon icon="people" scale="1.75" shift-v="1.25" aria-hidden="true"></b-icon>
      Offene Anfragen
    </b-breadcrumb-item>
  </b-breadcrumb>

  <ListLoader v-if="!dialogsSorted || dialogsSorted.length == 0"
     :speed="2"
     :animate="true"
   ></ListLoader>

  <b-alert v-for="dialog in dialogsSorted" :key="dialog.dialogueId"
    :show="5+10*Math.random()"
    dismissible
    variant="warning"
    >
      <dl>
        <dt>Start</dt>
        <dd>{{dialog.startTime | moment("DD. MMM YYYY // HH:mm")}}</dd>
        <dt>Channel</dt>
        <dd>{{dialog.channel}}</dd>
        <dt>Gesprächspartner</dt>
        <dd v-if="Math.random() < 0.5">{{dialog.participants[1].personName}}</dd>
        <dd v-else>Unbekannt</dd>
      </dl>

      <b-button @click="startDialog(dialog.dialogueId)">Konversation annehmen</b-button>
    </b-alert>

  </div>
</template>

<script>
import { ListLoader } from 'vue-content-loader';
import AllBusinessCasesUngrouped from '@/components/AllBusinessCasesUngrouped'

var _ = require('lodash');

export default {
  name: 'OpenDialogs',
  components: {
    ListLoader,
    AllBusinessCasesUngrouped
  },
  computed: {
    dialogs() {
      return this.$store.state.dialogs;
    },
    dialogsSorted() {
      return _.orderBy(this.$store.state.dialogs, 'startTime', 'desc');
    }
  },
  methods: {
    startDialog(dialogId) {
      this.$store.dispatch('getDialogByID', { 'dialogId': dialogId});
      this.$store.dispatch('getDialogStateByID', { 'dialogId': dialogId});
      this.$store.dispatch('getBusinessCasesOfDialog', { 'dialogId': dialogId});
    },

  },
}
</script>

<style scoped>
  .alert-warning {
    background-color: #FBF3E8;
  }
</style>
